import { Card, CardBody, Col } from "reactstrap";
import { PaginationAlignTitle } from "../../../Constants/Constants";
import { AlignBottomData, AlignCenterData, DefaultPageData, PageAlignSubTitle } from "../../../Data/BonusUi/Pagination";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DefaultPaginationList from "./Common/DefaultPaginationList";

const PaginationAlign = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={PaginationAlignTitle} span={PageAlignSubTitle} />
        <CardBody>
          <DefaultPaginationList pageClass="m-b-30" pageColor="warning" data={DefaultPageData} />
          <DefaultPaginationList pageClass="m-b-30" pageColor="danger" data={AlignCenterData} active listClass="justify-content-center" />
          <DefaultPaginationList pageClass="m-b-30" pageColor="success" data={AlignBottomData} listClass="justify-content-end" />
        </CardBody>
      </Card>
    </Col>
  );
};
export default PaginationAlign;
